import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Frame, Action } from '@studiometa/ui';
import { isDev } from './config.js';
import { DataComputed, DataModel } from '@studiometa/ui';
import Dropdown from './atoms/Dropdown.js';
import Header from './organisms/Header.js';
import Gallery from './organisms/Gallery.js';
import StickyPush from './molecules/StickyPush.js';
import ExternalClick from './molecules/Datalayer/ExternalClick.js';
import InternalClick from './molecules/Datalayer/InternalClick.js';
import Figure from './atoms/Figure.js';
import TopPop from './molecules/TopPop.js';
import Blog from './organisms/Blog.js';
import SearchWidget from './organisms/SearchWidget/index.js';
import ClaimFormRedirect from './organisms/ClaimFormRedirect.js';

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Action,
      Figure,
      Header,
      StickyPush,
      Frame,
      DataComputed,
      DataModel,
      TopPop,
      Blog,
      Newsletter: (app) =>
        importWhenVisible(() => import('./atoms/Newsletter.js'), 'Newsletter', app),
      '[target="_blank"]': ExternalClick,
      'a:not([target="_blank"])': InternalClick,
      FormClick: (app) =>
        importWhenVisible(() => import('./molecules/Datalayer/FormClick.js'), 'FormClick', app),
      SocialClick: (app) =>
        importWhenVisible(() => import('./molecules/Datalayer/SocialClick.js'), 'SocialClick', app),
      Dropdown,
      Gallery,
      Readmore: (app) => importWhenVisible(() => import('./atoms/Readmore.js'), 'Readmore', app),
      Stories: (app) =>
        importWhenVisible(() => import('./organisms/Stories/index.js'), 'Stories', app),

      Filters: (app) => importWhenVisible(() => import('./organisms/Filters.js'), 'Filters', app),
      SearchWidget,
      ClaimFormRedirect,
      VideosList: (app) =>
        importWhenVisible(() => import('./organisms/VideosList.js'), 'VideosList', app),
      DoubleGallery: (app) =>
        importWhenVisible(() => import('./organisms/DoubleGallery.js'), 'DoubleGallery', app),
      SimpleMap: (app) =>
        importWhenVisible(() => import('./molecules/Map/index.js'), 'SimpleMap', app),
      CardsList: (app) =>
        importWhenVisible(() => import('./organisms/CardsList.js'), 'CardsList', app),
      DestinationTabs: (app) =>
        importWhenVisible(() => import('./organisms/DestinationTabs.js'), 'DestinationTabs', app),
      Slider: (app) => importWhenVisible(() => import('./molecules/Slider.js'), 'Slider', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
    },
  };
}

export default createApp(App, document.body);
